import React, { Component } from "react";
import { Container, Row, Col, Image, Nav, Tab, Card, Dropdown, Modal, Button, Form } from "react-bootstrap";
import "./user.scss";
import Collection from "../../common/collection/collection";
import defaultPhoto from "../../images/default.png";
import { NavLink, withRouter, useParams } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignOutAlt, faEllipsisH, faHeart, faEllipsisV, faLock } from "@fortawesome/free-solid-svg-icons";
import IdentityService from "../../common/identityService";
import PhotoUpload from "../../common/photoUpload";
import Api from "../../common/api"
import ApiV2 from "../../common/apiV2"
import PropTypes from "prop-types";
import _ from "lodash";

const DEFAULT_COUNTRY_PHOTO = {
    USA: "https://www.virginholidays.co.uk/.imaging/Desktop/dam/0120998e-08f2-4805-b171-c71993976108.jpg",
    Germany: "https://www.studying-in-germany.org/wp-content/uploads/2013/02/how-to-study-in-germany.jpg",
    France: "https://media.cntraveler.com/photos/5d8cf7d5db6acf000833e6cc/master/pass/Eiffel-Tower_GettyImages-1060266626.jpg",
    Spain: "https://cdn.insuremytrip.com/resources/29337/spain_travel_insurance_seville.jpg",
    Greece: "https://www.azamara.com/sites/default/files/heros/jr-1-aug-2020-paros-greece-1800x1000_0.jpg",
    Italy: "https://cdn.cnn.com/cnnnext/dam/assets/170606121206-italy---travel-destination---shutterstock-517522957.jpg",
    Japan: "https://specials-images.forbesimg.com/imageserve/1179891725/960x0.jpg",
    Austrialia: "https://www.dbaudio.com/fileadmin/_processed_/1/8/csm_sydneyopera-house-au-2009-01_12a3f1a265.jpg",
    England: "https://news.itu.int/wp-content/uploads/2018/07/london-min-e1530887248858.jpg",
    China: "https://www.snopes.com/tachyon/2018/07/great_wall_of_china.jpg",
    Korea: "https://www.theinvisibletourist.com/wp-content/uploads/2019/08/featured_114.jpg",
    Thailand: "https://media.nomadicmatt.com/2019/11reasonsthailand.jpg",
    Default: "https://img.traveltriangle.com/blog/wp-content/tr:w-700,h-400/uploads/2018/09/swiss-alps.jpg"
}

class User extends Component {
    constructor(props) {
        super(props);

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);

        this.state = {
            userId: "",
            firstName: "",
            lastName: "",
            photoURL: "",
            userData: {},
            friendshipStatus: {isFollowing: false, pending: false},
            data: {},
            cities: [],
            countries: [],
            modalShow: false,
            setModalShow: false,
            shareLists: [],
            flag: false,
            isOpen: false,
            copySuccess: '',
            selectedSharelist: null,
            tempSharelist: null,
            registerClicked: false,
            successfulUpdate: false,
            checkboxChecked: false,
            following: 0,
            followers: 0,
            isLoading: true
        };
    }

    async componentDidMount() {
        var pathsplit = window.location.pathname.split('/');
        const userId = pathsplit[2];
        const isLoggedIn = await IdentityService.isLoggedIn();
        this.setState({
            isLoggedIn,
        });

        const userData = await ApiV2.getUser(userId);
        var isFollowing = await ApiV2.fetchFriendship(userId);
        const firstName = userData.firstName.charAt(0).toUpperCase() + userData.firstName.slice(1);
        const lastName = userData.lastName.charAt(0).toUpperCase() + userData.lastName.slice(1);
        const photoURL = userData.photoURL;

        var recData = [];
        var cities = [];
        var countries = [];
        var shareListsResponse = {};
        try {
            console.log("Getting spots");
            const { data } = await ApiV2.getUserRecommendationsById(userId);
            recData = data;
            cities = [...new Set(data.map(data => data.city))];
            countries = [...new Set(data.map(data => data.country))];

            console.log("Getting sharelists");
            shareListsResponse = await ApiV2.getSharelistsByUserId(userId);
        } catch(e){
            // TODO: Parse error and handle accordingly instead of assuming error was due to private and non friendship
            this.props.notifyInfo("Must follow user to view spots and collections");
        }

        const followersResponse = await ApiV2.getFollowCount(userId);
        const followingResponse = await ApiV2.getFollowingCount(userId);
        this.setState({
            userId: userId,
            userData: userData,
            firstName: firstName,
            lastName: lastName,
            data: recData,
            photoURL: photoURL,
            cities: cities,
            countries: countries,
            shareLists: shareListsResponse.data,
            following: followingResponse.Count,
            followers: followersResponse.Count,
            friendshipStatus: isFollowing.data,
            isLoading: false,
        })
        this.props.setUserRecs(recData);
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevState.flag !== this.state.flag) {
            try {
                var isFollowing = await ApiV2.fetchFriendship(this.state.userId);
                this.setState({ 
                    flag: false,
                    friendshipStatus: isFollowing.data
                 })
            } catch (error) {
                console.log("Could not update friendship status in UI: ", JSON.stringify(error));
            }
        }
    }

    getProfilePhoto() {
        if (this.state.photoURL) {
            return (this.state.photoURL);
        } else {
            return (defaultPhoto);
        }
    }

    openModal(sharelist){
        this.setState({ isOpen: true, selectedSharelist: sharelist });
    }

    closeModal(){
        this.setState({ isOpen: false, selectedSharelist: null })
    }

    copyToClipboard = (e) => {
        this.textArea.select();
        document.execCommand('copy');
        e.target.focus();
        this.setState({ copySuccess: 'Copied!' });
      };

    getSelectedSharelist(){
        if (this.state.selectedSharelist === null){
            return "";
        } else {
            return this.state.selectedSharelist;
        }
    }

    getTempSharelist(){
        if (this.state.tempSharelist === null){
            return "";
        } else {
            return this.state.tempSharelist;
        }
    }

    getProfilePhoto() {
        if (this.state.photoURL) {
            return (this.state.photoURL);
        } else {
            return (defaultPhoto);
        }
    }

    followUser = async (userId) => {
        try {
            const response = await ApiV2.followUser(userId);
            this.props.notifyInfo("Followed user");
            this.setState({flag: true});
        } catch (error) {
            this.props.notifyFailure("Couldn't follow user: ", JSON.stringify(error));
        }
    }

    unfollowUser = async (userId) => {
        try {
            const response = await ApiV2.unfollowUser(userId);
            this.props.notifyInfo("Unfollowed user");
            this.setState({flag: true});
        } catch (error) {
            this.props.notifyFailure("Couldn't unfollow user: ", JSON.stringify(error));
        }
    }

    savePublicSharelist = async (sharelist) => {
        try {
            const response = await ApiV2.savePublicSharelist(sharelist);
            this.props.notifyInfo("Saved sharelist");
        } catch (error) {
            this.props.notifyFailure("Could not save sharelist: ", JSON.stringify(error));
        }
    }

    getFollowButton() {
        if (this.state.isLoading){
            return
        } else {
            if (this.state.friendshipStatus.isFollowing){
                if(this.state.friendshipStatus.pending){
                    return(
                        <>
                        <Dropdown>
                        <Dropdown.Toggle variant="secondary" className="mr-1" size="sm" id="dropdown-basic" width="1000px">
                            Pending
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="bg-danger">
                            <Dropdown.Item onClick={() => this.unfollowUser(this.state.userId)} className="bg-danger text-light" href="#/action-1"><strong>Cancel</strong></Dropdown.Item>
                        </Dropdown.Menu>
                        </Dropdown>
                        </>
                    );
                } else {
                    return(
                        <>
                        <Dropdown>
                        <Dropdown.Toggle className="mr-1" size="sm" id="dropdown-basic" width="1000px">
                            Following
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="bg-danger">
                            <Dropdown.Item onClick={() => this.unfollowUser(this.state.userId)} className="bg-danger text-light" href="#/action-1"><strong>Unfollow</strong></Dropdown.Item>
                        </Dropdown.Menu>
                        </Dropdown>
                        </>
                    );
                }
            } else {
                return(
                    <Button onClick={() => this.followUser(this.state.userId)} className="mr-1" width="1000px" size="sm">Follow</Button> 
                );
            }
        }
    }

    renderRecommendations() {
        const countryCard = this.state.countries.map(country => {
            const places = _.filter(this.state.data, place => {
                return place.country === country;
            });
            var photo = DEFAULT_COUNTRY_PHOTO.Default;
            if (country in DEFAULT_COUNTRY_PHOTO) {
                photo = DEFAULT_COUNTRY_PHOTO[country]
            }
            return (
                <>
                    <Card className="country-cards mb-1">
                    <NavLink to="/user/listRecommendation" onClick={() => this.props.setCurrentRecList(country, places)}>
                        <Card.Img className="country-card-image" variant="top" src={photo} />
                    </NavLink>
                        <Card.Body className="pl-0 pr-0 pt-1 pb-1">
                            {country}
                            <p className="place-text text-secondary mb-0">{places.length} Places</p>
                        </Card.Body>
                    </Card>
                </>
            );
        });
        return countryCard
    }

    renderSharelists() {
        const shareListCards = this.state.shareLists?.map(sharelist => {
            return (
                <Collection
                    collection={sharelist}
                    collectionPath={`/user/sharelist/${sharelist.id}`}
                    collectionType="OTHERS"
                    setSelectedSharelist={this.props.setSelectedSharelist}
                    openModal={this.openModal}
                />
            );
        });
        return shareListCards;
    }

    renderModal() {
        return (
            <Modal className="p-2" show={this.state.isOpen} onHide={this.closeModal} centered>
                <Modal.Header>
                    <Modal.Title className="modal-title">{this.state.selectedSharelist?.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Button onClick={async () => this.savePublicSharelist(this.state.selectedSharelist)} variant="primary" block>
                        Save
                    </Button>
                    <Button onClick={this.closeModal} className="blue" variant="light" block>
                        Cancel
                    </Button>
                </Modal.Body>
            </Modal>
        );
    }

    render() {
        return (
            <Container className="child-container">
                {this.renderModal()}

                <Tab.Container defaultActiveKey="Passport">
                    <Row id="profile-header" className="align-items-center mt-2">
                        <Col xs="4" className="align-middle">
                            <Row className="justify-content-center">
                                <Dropdown>
                                    <Dropdown.Toggle className="p-1" variant="link">
                                        <Image id="profile-photo" src={this.getProfilePhoto()} roundedCircle></Image>
                                    </Dropdown.Toggle>
                                </Dropdown>
                            </Row>
                        </Col>
                        <Col xs="8" className="pl-0">
                            <Row className="justify-content-center">
                                <span className="font-weight-bold">
                                {this.state.userData.isPublic ? <></> : <FontAwesomeIcon className="mr-1 text-muted" icon={faLock} />}
                                    <span>{this.state.firstName}</span> <span>{this.state.lastName}</span>
                                </span>
                            </Row>
                            <Row className="justify-content-center" onClick={() => this.props.history.push(`/user/friends/${this.state.userId}`)}>
                                <span className="follow-row">
                                    <span className="font-weight-bold">{this.state.following}</span> Following | <span className="font-weight-bold">{this.state.followers}</span> Followers
                                </span>
                            </Row>

                            <Row className="justify-content-center profile-info-count">
                                <Col>
                                    <Row className="font-weight-bold justify-content-center">
                                        <span>{this.state.cities.length}</span>
                                    </Row>
                                    <Row className="justify-content-center">
                                        Cities
                                    </Row>
                                </Col>
                                <Col>
                                    <Row className="font-weight-bold justify-content-center">
                                        <span>{this.state.data.length ? this.state.data.length : 0}</span>
                                    </Row>
                                    <NavLink to="/user/listRecommendation" onClick={() => this.props.setCurrentRecList("My Places", this.state.data)}>
                                        <Row className="justify-content-center">
                                            Places
                                        </Row>
                                    </NavLink>
                                </Col>
                                <Col>
                                    <Row className="font-weight-bold justify-content-center">
                                        <span>{0}</span>
                                    </Row>
                                    <Row className="justify-content-center">
                                        Sharelists
                                    </Row>
                                </Col>
                            </Row>
                            
                            <Row className="justify-content-center">
                                {this.getFollowButton()}
                                <Button variant="outline-secondary" size="sm">Message</Button>
                            </Row>


                        </Col>
                    </Row>
                    <Row className="mt-2 mb-2">
                        <Col className="align-middle">
                            <Nav variant="pills" className="flex-row justify-content-center">
                                <Nav.Item>
                                    <Nav.Link className="profile-tab" eventKey="Passport">Passport</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link className="profile-tab" eventKey="Sharelist">Sharelist</Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </Col>
                    </Row>
                    <Row>
                        <Tab.Content id="profile-content">
                            <ChangeProfilePhotoModal
                                show={this.state.modalShow}
                                onHide={() => this.setState({ modalShow: false })}
                            />
                            <Tab.Pane eventKey="Passport">
                                <Container className="content-container" id="profile-container">
                                    <>{this.renderRecommendations()}</>
                                </Container>
                            </Tab.Pane>
                            <Tab.Pane eventKey="Sharelist">
                                <Container className="content-container">
                                    {this.renderSharelists()}
                                </Container>
                            </Tab.Pane>
                        </Tab.Content>
                    </Row>
                </Tab.Container>
            </Container>
        );
    }
}

function ChangeProfilePhotoModal(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Change profile photo
          </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <PhotoUpload
                    onHide={props.onHide}
                // setImageUrl={imageUrl => {
                //   this.setImageUrl(imageUrl);
                // }}
                // imageUrl={this.state.produceInModal.imageUrl}
                // notifyInfo={this.props.notifyInfo}
                // notifyFailure={this.props.notifyFailure}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}
export default withRouter(User);

User.propTypes = {
    userRecs: PropTypes.array.isRequired,
    setUserRecs: PropTypes.func.isRequired,
    setCurrentRecList: PropTypes.func.isRequired,
    setSelectedSharelist: PropTypes.func.isRequired,
    notifyInfo: PropTypes.func.isRequired,
    notifyFailure: PropTypes.func.isRequired
};
